import { useTheme } from '@emotion/react';
import React, { useRef } from 'react';

import { Box, Grid, Header, ScrollBox, Table } from '~/components/blocks';
import { SETTING_TITLES } from '~/components/layouts/Settings/RootMenu';
import { PrescriptionIdentify } from '~/components/pages/Settings_SystemSettings/PrescriptionIdentify';
import { useFeatureFlag } from '~/hooks/use-feature-flag';
import { usePlanFeature } from '~/hooks/use-plan-feature';

import { Checkin } from './Checkin';
import { CheckinSettingDrawer } from './CheckinSettingDrawer';
import { NotificationSetting } from './NotificationSetting';
import { NotificationSettingDrawer } from './NotificationSettingDrawer';
import { PrescriptionIdentifyDrawer } from './PrescriptionIdentifyDrawer';

export const SystemSettings = () => {
  const theme = useTheme();
  const scrollRef = useRef<RefAttributeType<typeof ScrollBox> | null>(null);
  const { hasEnabledFeature: hasEnabledCheckin } = usePlanFeature('checkin');
  const displayPrescriptionIdentifyItem = useFeatureFlag('Issue12646-yakumaru-feature');

  return (
    <>
      <Grid
        height="100%"
        gridGap={theme.space.l}
        gridTemplateRows="min-content 1fr"
        gridTemplateColumns="1fr"
      >
        <Header>{SETTING_TITLES.systemSettings}</Header>
        <Box height="100%" overflow="auto">
          <ScrollBox ref={scrollRef}>
            <Table whiteSpace="nowrap">
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>名称</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                <NotificationSetting />
                {hasEnabledCheckin && <Checkin />}
                {displayPrescriptionIdentifyItem && <PrescriptionIdentify />}
              </Table.Tbody>
            </Table>
          </ScrollBox>
        </Box>
      </Grid>
      <CheckinSettingDrawer />
      <NotificationSettingDrawer />
      <PrescriptionIdentifyDrawer />
    </>
  );
};
